export const RADIO_STREAMS = [
  {
    name: 'WeFunk Radio',
    url: 'https://www.wefunkradio.com/play/radio.mp3'
  },
  {
    name: 'FIP Hip Hop',
    url: 'http://icecast.radiofrance.fr/fiphiphop-hifi.aac'
  },
  {
    name: 'Jazz Radio Funk',
    url: 'http://jazz-wr06.ice.infomaniak.ch/jazz-wr06-128.mp3'
  },
  {
    name: 'C-LAB',
    url: 'https://www.c-lab.fr/stream/'
  },
  {
    name: 'bigFM Oldschool Rap & Hip-Hop',
    url: 'http://streams.bigfm.de/bigfm-oldschool-128-aac'
  }
];

export const DRUM_BREAKS = [
  { title: 'Basic Rock 1 - Drum Groove', url: 'https://www.youtube.com/watch?v=nrHRYliYNQk' },
  { title: 'Basic Rock 2 - Drum Groove', url: 'https://www.youtube.com/watch?v=QO-VkxqhURc' },
  { title: 'Basic Rock 3 - Drum Groove', url: 'https://www.youtube.com/watch?v=gr7X2QCI7s8' },
  { title: 'Bembé "Afro-Cuban 6/8" - Drum Groove', url: 'https://www.youtube.com/watch?v=ptlBWTHeCrs' },
  { title: 'Bembé "Afro-Cuban 6/8" (Variation 1) - Drum Groove', url: 'https://www.youtube.com/watch?v=WvuyJ5F6AhI' },
  { title: 'Bossa Nova (Hi-hat) - Drum Groove', url: 'https://www.youtube.com/watch?v=mZ_mEmaJu98' },
  { title: 'Bossa Nova (Ride Cymbal) - Drum Groove', url: 'https://www.youtube.com/watch?v=YruAZhDN3ZQ' },
  { title: 'Breakbeat 1 - Drum Groove', url: 'https://www.youtube.com/watch?v=L4tPLQgd69o' },
  { title: 'Breakbeat 2 - Drum Groove "Streets of Philadelphia"', url: 'https://www.youtube.com/watch?v=KwgAHqLjRJ0' },
  { title: 'Linear 1 - Drum Groove', url: 'https://www.youtube.com/watch?v=9kcWSuJNwv4' },
  { title: 'Linear 2 - Drum Groove', url: 'https://www.youtube.com/watch?v=FKEtOi0gqoM' },
  { title: 'Mambo - Drum Groove', url: 'https://www.youtube.com/watch?v=irJsKRITa7M' },
  { title: 'Nanigo - Drum Groove', url: 'https://www.youtube.com/watch?v=YCk23hF-Gxk' },
  { title: 'Palito - Drum Groove', url: 'https://www.youtube.com/watch?v=vZSziK06nbE' },
  { title: 'Plena - Drum Groove', url: 'https://www.youtube.com/watch?v=a6zoXwyvCV4' },
  { title: 'Purdie Shuffle - Drum Groove', url: 'https://www.youtube.com/watch?v=cOB2hhc4ikU' },
  { title: 'Sikyi - Drum Groove', url: 'https://www.youtube.com/watch?v=S3fGkJ9IYFQ' },
  { title: 'Sikyi (Variation 1) - Drum Groove', url: 'https://www.youtube.com/watch?v=On4On-wc6ro' },
  { title: 'Soca - Drum Groove', url: 'https://www.youtube.com/watch?v=JqBDG5ga7Fc' },
  { title: 'Songo - Drum Groove', url: 'https://www.youtube.com/watch?v=fjPW6UOkHf4' }
];

export const DJ_MIXES = [
  // Prêt pour le futur
]; 